import { render, staticRenderFns } from "./ClientContactCard.vue?vue&type=template&id=47f7a4e9&"
import script from "./ClientContactCard.vue?vue&type=script&lang=js&"
export * from "./ClientContactCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports